import moment from 'moment';
import { Field } from '../field';
import { SubmissionGlobalValue } from '../../formulas/types/ComputerDefinition';

export const REPORT_DATE_GLOBALS_NAMES = [
  'reportDate',
  'startOfSeaPassage',
  'endOfSeaPassage',
  'delayStartTime',
];

export class DateTimeGMTField extends Field {
  /**
   * Customise the initialise value function so the consumption numbers default to 0
   * if they don't already have a value
   * @param reportDate
   * @param globalValues
   */
  initialiseValue(
    reportDate: Date | string,
    globalValues: SubmissionGlobalValue[],
  ) {
    super.initialiseValue(reportDate, globalValues);

    // If this field has a global attached to it that is the equivelant of the report date
    // We need to set its content equal to that of the report date
    const reportDateGlobalsIds = this.context.sharedGlobals
      .filter((sharedGlobal) => REPORT_DATE_GLOBALS_NAMES.includes(sharedGlobal.name))
      .map((sharedGlobal) => sharedGlobal.id);

    if (
      this.fieldDef.global
      && reportDateGlobalsIds.includes(this.fieldDef.global.id)
    ) {
      setTimeout(() => {
        const dateField = this.context.initialisedFields.find(
          (field) => field.id === this.fieldDef.children![0],
        );
        const timeField = this.context.initialisedFields.find(
          (field) => field.id === this.fieldDef.children![1],
        );
        const offsetField = this.context.initialisedFields.find(
          (field) => field.id === this.fieldDef.children![2],
        );

        // I don't get what this stupid eslint rule is saying!
        // eslint-disable-next-line no-unused-expressions
        dateField?.setContent(
          moment.parseZone(reportDate).format('YYYY-MM-DD')
        );
        // eslint-disable-next-line no-unused-expressions
        dateField?.setDisabled(true);

        // eslint-disable-next-line no-unused-expressions
        timeField?.setContent(moment.parseZone(reportDate).format('HH:mm'));
        // eslint-disable-next-line no-unused-expressions
        timeField?.setDisabled(true);

        const offset = moment.parseZone(reportDate).format('Z');
        // eslint-disable-next-line no-unused-expressions
        offsetField?.setContent(offset);
        // eslint-disable-next-line no-unused-expressions
        offsetField?.setDisabled(true);
      }, 0);
    }
  }
}
